import { render, staticRenderFns } from "./UsersPrivilegeCustodies.vue?vue&type=template&id=9d8fb036&scoped=true&"
import script from "./UsersPrivilegeCustodies.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeCustodies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8fb036",
  null
  
)

export default component.exports